import { render, staticRenderFns } from "./ModalEditarEleicoes.vue?vue&type=template&id=3a7679c0"
import script from "./ModalEditarEleicoes.vue?vue&type=script&lang=js"
export * from "./ModalEditarEleicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports